import type { ReactNode } from "react"

import { cn } from "../../lib/utils"

type FormFieldProps = {
  id: string
  label: string
  hint?: string
  error?: string | null
  className?: string
  children: (controlProps: { "aria-describedby"?: string }) => ReactNode
}

export function FormField({ id, label, hint, error, className, children }: FormFieldProps) {
  const descriptionId = hint || error ? `${id}-description` : undefined
  return (
    <div className={cn("space-y-1.5", className)}>
      <label htmlFor={id} className="block text-[13px] font-medium text-foreground">
        {label}
      </label>

      <div>{children(descriptionId ? { "aria-describedby": descriptionId } : {})}</div>

      {hint || error ? (
        <p
          id={descriptionId}
          className={cn("text-xs", error ? "text-destructive" : "text-muted-foreground")}
        >
          {error ?? hint}
        </p>
      ) : null}
    </div>
  )
}
